<script lang="ts">
  import { writable } from 'svelte/store';
  import Alert from './Alert.svelte';
  import Spinner from './Spinner.svelte';
  import { session } from '$lib/stores';

  const status = writable<'idle' | 'loading' | 'success' | 'error'>('idle');

  const onSendVerification = async () => {
    if ($session) {
      $status = 'loading';
      const res = await fetch('/api/session/send-verification', { method: 'POST' });

      if (res.ok) {
        $status = 'success';
      } else {
        $status = 'error';
      }
    }
  };
</script>

{#if $session && !$session?.email_verified_at}
  <Alert severity="warning">
    <p>Para poder ofertar primero debe verificar su dirección de correo electrónico.</p>
    <div class="flex justify-center">
      <button
        class="mt-4 inline-flex items-center rounded border border-transparent bg-yellow-400 px-2.5 py-1.5 text-xs font-medium text-white shadow-sm hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2"
        type="button"
        on:click={onSendVerification}
        disabled={$status == 'loading'}
      >
        {#if $status == 'loading'}<Spinner />{/if}
        Reenviar correo de verificación
      </button>
    </div>
  </Alert>
{/if}
